import {useEffect, useState} from "react";
import '../CarPreview/CarPreview.scss';
import  './Carousel.scss';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
// import {LeftCircleFilled, RightCircleFilled} from "@ant-design/icons";
import {LeftOutlined, RightOutlined} from '@ant-design/icons';

const ImageCarousel = ({showCarousleDots=true,selectedImage,customPrevArrow,customNextArrow,imageUrls,carouselKey,redirectOnClick=false,redirectURL=false}) => {
    let imageUrlsdummy = ["https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/1efe9907-1ecf-4437-acaa-85d33641f31c",
        "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/65fcf643-61e7-4399-85ec-db9ad20f8d99",
        "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/677fc9f2-c755-45bb-a10b-380b4459ff7e",
        "https://img.pmsrv.co/v1/media/39b53813-2cae-4c90-98db-e986df647eb7/360da5ed-d626-4f8d-b693-f42d1278d8ac"]

    return (
        <>
            {/*<div className="car-image-name-container relative gcd-image-click">*/}
            {/*    <div className="carousel-parent-container">*/}
            {/*        <Carousel autoPlay={false}*/}
            {/*            renderArrowPrev={customPrevArrow}*/}
            {/*            renderArrowNext={customNextArrow}*/}
            {/*                  showStatus={false}*/}
            {/*                  showArrows={true}*/}
            {/*                  thumbWidth={0}*/}
            {/*                  interval={1800}*/}
            {/*                  selectedItem={selectedImage}*/}
            {/*            dynamicHeight={true}*/}
            {/*                  // width={300}*/}
            {/*                  // height={150}*/}
            {/*                  className="carousel-class"*/}
            {/*        >*/}
            {/*            {*/}
            {/*                imageUrls?.slice(0, 4)?.map((imageUrl) => {*/}
            {/*                    return (*/}
            {/*                        <div className="car-image overlay" key={imageUrl}*/}
            {/*                            // id={getImageShotId(imageUrl)}*/}
            {/*                            >*/}
            {/*                            <img src={imageUrl}/>*/}
            {/*                        </div>*/}
            {/*                    )*/}
            {/*                })*/}
            {/*            }*/}
            {/*        </Carousel>*/}
            {/*    </div>*/}
            {/*</div>*/}
           <Carousel key={carouselKey} selectedItem={selectedImage} showThumbs={false} showStatus={false}  renderArrowPrev={customPrevArrow} renderArrowNext={customNextArrow}
                     renderIndicator={(onClickHandler, isSelected, index, label) => {
                        if(showCarousleDots){
                            const dotStyle = {
                                width: "5px",
                                height: "5px",
                                // boxShadow:"rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
                                // boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
                                backgroundColor: isSelected ? "#526FFF" : "#526FFF80",
                                borderRadius: "50%",
                                display: "inline-block",
                                marginLeft: "5px", // Adjust margin between dots as needed
                                cursor: "pointer",
                            };

                            return (
                                <span
                                    onClick={onClickHandler}
                                    onKeyDown={onClickHandler}
                                    value={index}
                                    key={index}
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`${label} ${index + 1}`}
                                    style={dotStyle}
                                    className="carousel-custom-dots"
                                />
                            );
                        }else{
                            return null
                        }
                     }}

           >
               {   imageUrls?.slice(0, 4)?.map((imageUrl) => {
                                   return (
                                    redirectOnClick && redirectURL ? 
                                        <a href={redirectURL} onClick={(e) => e.stopPropagation()} target="_blank" className="car-image overlay" key={imageUrl}
                                            // id={getImageShotId(imageUrl)}
                                            >
                                            <img src={imageUrl} style={{minHeight:"211px",objectFit:"contain"}}/>
                                        </a> : 
                                        <div className="car-image overlay" key={imageUrl}
                                            // id={getImageShotId(imageUrl)}
                                            >
                                            <img src={imageUrl} style={{minHeight:"211px",objectFit:"contain"}}/>
                                        </div>
                                       
                                   )
                               })
                           }
           </Carousel>
        </>
    )
}
export default ImageCarousel;